import { createRoot, hydrateRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';

// Stand-ins for the legacy ReactDOM.render / unmountComponentAtNode that React 19
// removed. Rendering into a container again updates the tree that's already there,
// and rendering is synchronous, as it was with ReactDOM.render, so jQuery code that
// reads the DOM right after mounting still sees the output.
//
// Pass { sync: false } when calling from inside a React render or lifecycle, where
// React can't flush synchronously; the tree renders with React's next update.
const rootsByContainer = new WeakMap();

export function renderIntoContainer(element, container, { sync = true } = {}) {
	let root = rootsByContainer.get(container);
	if(!root) {
		root = createRoot(container);
		rootsByContainer.set(container, root);
	}
	if(sync) {
		flushSync(() => {
			root.render(element);
		});
	}
	else {
		root.render(element);
	}
	return root;
}

// Attaches to HTML the ssr service rendered into the container, instead of
// replacing it. Later renderIntoContainer calls update the hydrated tree.
export function hydrateIntoContainer(element, container) {
	const root = hydrateRoot(container, element);
	rootsByContainer.set(container, root);
	return root;
}

export function unmountContainer(container) {
	const root = rootsByContainer.get(container);
	if(!root) {
		return false;
	}
	rootsByContainer.delete(container);
	root.unmount();
	return true;
}
